import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, createElementBlock as _createElementBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-021f06a1"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "col-md-6 mx-auto my-5"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "mb-3" }, "FCA views and adviser signposts", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " The FCA believes that a transfer is highly unlikely to be suitable for someone who: ", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, "Has no tolerance for risk"),
  /*#__PURE__*/_createElementVNode("li", null, "Has no other guaranteed income to support them in retirement"),
  /*#__PURE__*/_createElementVNode("li", null, " Can achieve their desired income using the current scheme benefits and everything else they have "),
  /*#__PURE__*/_createElementVNode("li", null, " Wants the same type of income as the current scheme benefits provides and does not require any flexibility "),
  /*#__PURE__*/_createElementVNode("li", null, " Does not understand the risks involved in using a transfer value rather than the scheme benefits to provide the desired income ")
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Unless they are in serious ill health, or in serious financial difficulty. ", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "mt-4 mb-3" }, "What to do next?", -1))
const _hoisted_7 = {
  class: "alert alert-warning",
  role: "alert"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Note for Trustees:", -1))
const _hoisted_9 = {
  class: "alert alert-warning",
  role: "alert"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " This button will not be available on the member site, but it can be used to view the other outcome. ", -1))
const _hoisted_11 = { key: 1 }
const _hoisted_12 = {
  key: 2,
  class: "col-md-6 mx-auto my-5"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_yes_outcome = _resolveComponent("yes-outcome")!
  const _component_no_outcome = _resolveComponent("no-outcome")!
  const _component_guiide_advisors = _resolveComponent("guiide-advisors")!
  const _component_origen_advisors = _resolveComponent("origen-advisors")!
  const _component_nav_buttons = _resolveComponent("nav-buttons")!
  const _component_review_answers = _resolveComponent("review-answers")!

  return (_ctx.showOutcomeArea)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _hoisted_3,
        _hoisted_4,
        _hoisted_5,
        _hoisted_6,
        (_ctx.showYesOutcome)
          ? (_openBlock(), _createBlock(_component_yes_outcome, {
              key: 0,
              onShowTransferAdvisorsRequired: _ctx.onNextClicked
            }, null, 8, ["onShowTransferAdvisorsRequired"]))
          : (_openBlock(), _createBlock(_component_no_outcome, {
              key: 1,
              onShowRetirementAdvisorsRequired: _ctx.onNextClicked
            }, null, 8, ["onShowRetirementAdvisorsRequired"])),
        _withDirectives(_createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createTextVNode(" the final Guiide site directed to above will contain no partners, except for a general at retirement adviser ")
        ], 512), [
          [_vShow, false]
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("input", {
            type: "button",
            value: "View Other Outcome",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.forceOtherOutcome && _ctx.forceOtherOutcome(...args)))
          })
        ], 512), [
          [_vShow, false]
        ])
      ]))
    : (_ctx.showAdvisorsArea)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          (_ctx.showGuiide)
            ? (_openBlock(), _createBlock(_component_guiide_advisors, {
                key: 0,
                showYesOutcome: _ctx.showYesOutcome
              }, null, 8, ["showYesOutcome"]))
            : _createCommentVNode("", true),
          (_ctx.isOrigen)
            ? (_openBlock(), _createBlock(_component_origen_advisors, {
                key: 1,
                showYesOutcome: _ctx.showYesOutcome
              }, null, 8, ["showYesOutcome"]))
            : _createCommentVNode("", true),
          _createVNode(_component_nav_buttons, {
            previousVisible: true,
            previousMuted: false,
            previousShowArrow: true,
            nextVisible: false,
            onPreviousClicked: _ctx.onReturnToOutcomeClicked
          }, null, 8, ["onPreviousClicked"])
        ]))
      : (_ctx.showAnswersArea)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createVNode(_component_review_answers),
            _createVNode(_component_nav_buttons, {
              previousVisible: true,
              previousMuted: false,
              previousShowArrow: true,
              nextVisible: false,
              onPreviousClicked: _ctx.onReturnToOutcomeClicked
            }, null, 8, ["onPreviousClicked"])
          ]))
        : _createCommentVNode("", true)
}